"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = void 0;
const lodash_isundefined_1 = __importDefault(require("lodash.isundefined"));
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const lodash_uniq_1 = __importDefault(require("lodash.uniq"));
const lodash_groupby_1 = __importDefault(require("lodash.groupby"));
class HeaderTransformer {
  parserOptions;
  headers = null;
  receivedHeaders = false;
  shouldUseFirstRow = false;
  processedFirstRow = false;
  headersLength = 0;
  headersTransform;
  constructor(parserOptions) {
    this.parserOptions = parserOptions;
    if (parserOptions.headers === true) {
      this.shouldUseFirstRow = true;
    } else if (Array.isArray(parserOptions.headers)) {
      this.setHeaders(parserOptions.headers);
    } else if ((0, lodash_isfunction_1.default)(parserOptions.headers)) {
      this.headersTransform = parserOptions.headers;
    }
  }
  transform(row, cb) {
    if (!this.shouldMapRow(row)) {
      return cb(null, {
        row: null,
        isValid: true
      });
    }
    return cb(null, this.processRow(row));
  }
  shouldMapRow(row) {
    const {
      parserOptions
    } = this;
    if (!this.headersTransform && parserOptions.renameHeaders && !this.processedFirstRow) {
      if (!this.receivedHeaders) {
        throw new Error('Error renaming headers: new headers must be provided in an array');
      }
      this.processedFirstRow = true;
      return false;
    }
    if (!this.receivedHeaders && Array.isArray(row)) {
      if (this.headersTransform) {
        this.setHeaders(this.headersTransform(row));
      } else if (this.shouldUseFirstRow) {
        this.setHeaders(row);
      } else {
        // dont do anything with the headers if we didnt receive a transform or shouldnt use the first row.
        return true;
      }
      return false;
    }
    return true;
  }
  processRow(row) {
    if (!this.headers) {
      return {
        row: row,
        isValid: true
      };
    }
    const {
      parserOptions
    } = this;
    if (!parserOptions.discardUnmappedColumns && row.length > this.headersLength) {
      if (!parserOptions.strictColumnHandling) {
        throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${row.length}`);
      }
      return {
        row: row,
        isValid: false,
        reason: `Column header mismatch expected: ${this.headersLength} columns got: ${row.length}`
      };
    }
    if (parserOptions.strictColumnHandling && row.length < this.headersLength) {
      return {
        row: row,
        isValid: false,
        reason: `Column header mismatch expected: ${this.headersLength} columns got: ${row.length}`
      };
    }
    return {
      row: this.mapHeaders(row),
      isValid: true
    };
  }
  mapHeaders(row) {
    const rowMap = {};
    const {
      headers,
      headersLength
    } = this;
    for (let i = 0; i < headersLength; i += 1) {
      const header = headers[i];
      if (!(0, lodash_isundefined_1.default)(header)) {
        const val = row[i];
        // eslint-disable-next-line no-param-reassign
        if ((0, lodash_isundefined_1.default)(val)) {
          rowMap[header] = '';
        } else {
          rowMap[header] = val;
        }
      }
    }
    return rowMap;
  }
  setHeaders(headers) {
    const filteredHeaders = headers.filter(h => {
      return !!h;
    });
    if ((0, lodash_uniq_1.default)(filteredHeaders).length !== filteredHeaders.length) {
      const grouped = (0, lodash_groupby_1.default)(filteredHeaders);
      const duplicates = Object.keys(grouped).filter(dup => {
        return grouped[dup].length > 1;
      });
      throw new Error(`Duplicate headers found ${JSON.stringify(duplicates)}`);
    }
    this.headers = headers;
    this.receivedHeaders = true;
    this.headersLength = this.headers?.length || 0;
  }
}
exports.HeaderTransformer = HeaderTransformer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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